<template>
  <div class="c-logo">
    <a href="/">
      <img :src="logoSrc" alt="Manchester University NHS Foundation Trust" />
    </a>
  </div>
</template>

<script>
import logo from '@/assets/images/mft-logo.png';

export default {
  name: 'mft-logo',

  computed: {
    logoSrc() {
      return logo;
    },
  },
};
</script>

<style lang="scss">
.c-logo img {
  height: auto;
  max-width: 150px;
}

@media screen and (min-width: 1024px) {
  .c-logo img {
    height: auto;
    max-width: 200px;
  }
}
</style>
